// ComercialTabXL - Sprint 44 Fase 3 Vista 2.
// Configuracion comercial: moneda, lista de precios, tipo de cliente,
// vendedor, credito (condicional), tipo de descuento, notas de pago.
// [FIX] NumInput crudo para limite_credito -> XLMoneyInput (output number).
import { useEffect } from 'react';
import { ensureKeyframes, injectCSS } from '../../../design/motion';
import XLInput from '../../../components/xl/XLInput';
import XLSelect from '../../../components/xl/XLSelect';
import XLMoneyInput from '../../../components/xl/XLMoneyInput';
import {
  MONEDAS, LISTAS_PRECIOS, TIPO_CLIENTE, TIPO_DESCUENTO,
} from '../../clientes/form/utils';

const CSS_ID = 'xl-cli-comercial-css';
const CSS = `
.xl-form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}
@media (max-width: 720px) { .xl-form-grid { grid-template-columns: 1fr } }
.xl-form-grid__full { grid-column: 1 / -1 }
`;

const MONEDA_OPTIONS = MONEDAS.map((m) => ({ value: m, label: m }));
const TIPO_DESC_OPTIONS = TIPO_DESCUENTO;  // ya tiene shape {value,label}

export default function ComercialTabXL({ form, set }) {
  useEffect(() => {
    ensureKeyframes();
    injectCSS(CSS_ID, CSS);
  }, []);

  const esCredito = form.tipo_cliente === 'credito';
  const tipoDescActual = form.tipo_descuento || '';

  return (
    <div className="xl-form-grid">
      <XLSelect
        label="Moneda preferida"
        value={form.moneda_preferida || 'COP'}
        onChange={(e) => set('moneda_preferida', e.target.value)}
        options={MONEDA_OPTIONS}
      />
      <XLSelect
        label="Lista de precios"
        value={form.lista_precios || 'general'}
        onChange={(e) => set('lista_precios', e.target.value)}
        options={LISTAS_PRECIOS}
      />
      <XLSelect
        label="Tipo de cliente"
        value={form.tipo_cliente || 'contado'}
        onChange={(e) => set('tipo_cliente', e.target.value)}
        options={TIPO_CLIENTE}
      />
      <XLInput
        label="Vendedor asignado (ID)"
        type="number"
        value={form.vendedor_id === null || form.vendedor_id === undefined ? '' : form.vendedor_id}
        onChange={(e) => {
          const v = e.target.value;
          set('vendedor_id', v === '' ? null : Number(v));
        }}
        placeholder="ID usuario"
      />

      {esCredito && (
        <>
          <XLInput
            label="Dias de credito"
            type="number"
            value={form.dias_credito === null || form.dias_credito === undefined ? '' : form.dias_credito}
            onChange={(e) => {
              const v = e.target.value;
              set('dias_credito', v === '' ? null : Number(v));
            }}
            placeholder="30"
          />
          <XLMoneyInput
            label="Limite de credito"
            moneda={form.moneda_preferida || 'COP'}
            value={form.limite_credito}
            onChange={(n) => set('limite_credito', n)}
            placeholder="0,00"
          />
        </>
      )}

      <XLSelect
        label="Tipo de descuento"
        value={tipoDescActual}
        onChange={(e) => set('tipo_descuento', e.target.value)}
        options={TIPO_DESC_OPTIONS}
      />

      <div className="xl-form-grid__full">
        <XLInput
          label="Notas de pago"
          hint="Instrucciones para el area de pagos (cuenta bancaria, condiciones especiales...)"
          value={form.notas_pago || ''}
          onChange={(e) => set('notas_pago', e.target.value)}
        />
      </div>
    </div>
  );
}
